import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {VgCoreModule} from 'videogular2/core';
import {VgControlsModule} from 'videogular2/controls';
import {VgOverlayPlayModule} from 'videogular2/overlay-play';
import {VgBufferingModule} from 'videogular2/buffering';
import {VideoPlayer5Component} from './video-player-5.component';
import {ModalVideoComponent} from '../../components/modals/modal-video/modal-video.component';
import {TranslatePipe5} from '../../pipes/translate/translate5.pipe';
import {ModalVideoRoundComponent} from '../../components/modals/modal-video-round/modal-video-round.component';

@NgModule({
    declarations: [VideoPlayer5Component, TranslatePipe5],
    imports: [
        CommonModule,
        FormsModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule
    ],
    exports: [VideoPlayer5Component],
    entryComponents: [
        ModalVideoComponent,
        ModalVideoRoundComponent
    ]
})
export class VideoPlayer5ComponentModule {
}
